import TextKeys from '../figma/texts.json'

export default TextKeys
